import(/* webpackMode: "eager", webpackExports: ["Content"] */ "/app/src/app/(ru)/masterclasses/[wordId]/ui/content.tsx");
